import { useContext } from 'react'
import { OrganizationContextType, OrganizationContext } from './index'

const useOrganization = (): OrganizationContextType =>
  useContext(OrganizationContext)

export default useOrganization
